/**
 * Arabic strings, carried over from the design prototype.
 *
 * Keyed by the English source string so an untranslated key falls back to
 * readable English rather than a blank or a dotted key path.
 */
export const AR: Record<string, string> = {
  Language: 'اللغة',
  Collapse: 'تصغير',
  Search: 'بحث',
  Connected: 'متصل',
  Dashboard: 'لوحة المعلومات',
  Main: 'الرئيسية',
  Sales: 'المبيعات',
  Purchases: 'المشتريات',
  Inventory: 'المخزون',
  Finance: 'المالية',
  Admin: 'الإدارة',
  Invoices: 'فواتير المبيعات',
  Quotes: 'عروض الأسعار',
  Customers: 'العملاء',
  Bills: 'فواتير المشتريات',
  'Purchase orders': 'أوامر الشراء',
  Suppliers: 'الموردون',
  'Products and services': 'المنتجات والخدمات',
  "What's in stock?": 'المتوفر في المخزون',
  'Xero connection': 'الاتصال بـ Xero',
  'Save as draft': 'حفظ كمسودة',
  Discard: 'إلغاء',
  'New invoice': 'فاتورة جديدة',
  'New bill': 'فاتورة مشتريات جديدة',
  'New quote': 'عرض سعر جديد',
  'New purchase order': 'أمر شراء جديد',
  'New contact': 'جهة اتصال جديدة',
  'New item': 'منتج جديد',
  'Add another line': 'إضافة سطر',
  'Line items': 'بنود الفاتورة',
  Subtotal: 'المجموع الفرعي',
  'Total tax': 'إجمالي الضريبة',
  Total: 'الإجمالي',
  Export: 'تصدير',
  Filter: 'تصفية',
  Contact: 'جهة الاتصال',
  'Issue date': 'تاريخ الإصدار',
  'Due date': 'تاريخ الاستحقاق',
  'Invoice number': 'رقم الفاتورة',
  Reference: 'المرجع',
  Currency: 'العملة',
  'Amounts are': 'المبالغ',
  Description: 'الوصف',
  Qty: 'الكمية',
  'Unit Price': 'سعر الوحدة',
  Account: 'الحساب',
  'Tax Rate': 'نسبة الضريبة',
  Amount: 'المبلغ',
  Item: 'المنتج',
  'Disc.': 'الخصم',

  'Push queue': 'قائمة الإرسال',
  'Push log': 'سجل الإرسال',
  'Sign out': 'تسجيل الخروج',
  'Your client organisations': 'مؤسسات عملائك',
  'Scoped by your entitlement on the server. Switching reloads every screen against that organisation only.':
    'النطاق محدد بصلاحيتك على الخادم. التبديل يعيد تحميل كل الشاشات لهذه المؤسسة فقط.',
  'Client connections': 'اتصالات العملاء',
  'Choose…': 'اختر…',
  'Type to search…': 'اكتب للبحث…',
  'PDF': 'PDF',
  'Print': 'طباعة',
  'Print our own bilingual layout, with the logo set here': 'اطبع تنسيقنا ثنائي اللغة، بالشعار المحدد هنا',
  'Print or save as PDF': 'اطبع أو احفظ كـ PDF',
  '← Back': '→ رجوع',
  'That document could not be read from Xero.': 'تعذّر قراءة هذا المستند من Xero.',
  'No logo has been set for this organisation. Admin → Branding.': 'لم يُحدَّد شعار لهذه المؤسسة. الإدارة ← الهوية.',
  'Branding': 'الهوية',
  'The logo on documents this app prints. Xero keeps its own branding for the PDFs it produces.': 'الشعار على المستندات التي يطبعها هذا التطبيق. تحتفظ Xero بهويتها الخاصة لملفات PDF التي تنتجها.',
  'No logo yet. Documents will print with the company name only.': 'لا يوجد شعار بعد. ستُطبع المستندات باسم المؤسسة فقط.',
  'Upload a logo': 'رفع شعار',
  'Replace the logo': 'استبدال الشعار',
  'The current logo': 'الشعار الحالي',
  'PNG, JPEG or WebP. Up to 256 KB.': 'PNG أو JPEG أو WebP. حتى 256 كيلوبايت.',
  'That has to be a PNG, JPEG or WebP image.': 'يجب أن تكون صورة PNG أو JPEG أو WebP.',
  'That image is too large. The limit is 256 KB.': 'الصورة كبيرة جداً. الحد 256 كيلوبايت.',
  'That file is not the kind of image it says it is.': 'هذا الملف ليس من نوع الصورة الذي يدّعيه.',
  'That file is empty.': 'هذا الملف فارغ.',
  'Uploaded': 'رُفع في',
  'Open the PDF Xero produces, with this company’s own branding': 'افتح ملف PDF الذي تنتجه Xero بهوية هذه المؤسسة',
  'Nothing matches that.': 'لا يوجد ما يطابق ذلك.',
  '+ Add a contact': '+ إضافة جهة اتصال',
  '+ Add a product or service': '+ إضافة منتج أو خدمة',
  'Bank': 'البنك',
  'Current asset': 'أصول متداولة',
  'Current liability': 'التزامات متداولة',
  'Depreciation': 'الإهلاك',
  'Direct costs': 'التكاليف المباشرة',
  'Equity': 'حقوق الملكية',
  'Expense': 'المصروفات',
  'Fixed asset': 'أصول ثابتة',
  /* 'Inventory' and 'Sales' are already above, as sidebar headings, with
     the same translations — so these two account types are covered. */
  'Liability': 'الالتزامات',
  'Non-current asset': 'أصول غير متداولة',
  'Other income': 'إيرادات أخرى',
  'Overhead': 'مصروفات عمومية',
  'Prepayment': 'مدفوعات مقدمة',
  'Revenue': 'الإيرادات',
  'Term liability': 'التزامات طويلة الأجل',
  'Tax liability': 'التزامات ضريبية',
  'Pension expense': 'مصروف المعاشات',
  'Pension liability': 'التزام المعاشات',
  'Wages': 'الأجور',
  'Wages payable': 'أجور مستحقة',
  'Other': 'أخرى',
  'Client view': 'عرض العميل',
  'People': 'الأشخاص',
  'Sales and purchases': 'المبيعات والمشتريات',
  'Record a payment': 'تسجيل دفعة',
  '← All client connections': '→ كل اتصالات العملاء',
  'One connection per client organisation. The backend owns the tokens; reads happen on demand, never as a background sync.': 'اتصال واحد لكل مؤسسة عميل. الخادم يملك الرموز؛ والقراءة عند الطلب فقط، وليست مزامنة في الخلفية.',
  'This connection is missing a permission the application now needs': 'ينقص هذا الاتصال صلاحية يحتاجها التطبيق الآن',
  'Granted before it was added:': 'مُنح قبل إضافتها:',
  'Connect this organisation again to include it. Nothing is lost by reconnecting.': 'أعد ربط هذه المؤسسة لتضمينها. لا يُفقد شيء بإعادة الربط.',
  'Reconnect this organisation': 'إعادة ربط هذه المؤسسة',

  /* ---------------------------------------------------------------------
     What CFOAI gave this client. Two switches, deliberately separate:
     Training is a section in this product, Xero Projects is a permission
     on the client's own Xero connection. One does not need the other.
  --------------------------------------------------------------------- */

  /* ---------------------------------------------------------------------
     Training setup: which accounts carry a course cost, and what has
     fallen out. The flag is only as good as the account list, which is
     why both live on one screen.
  --------------------------------------------------------------------- */
  'Training setup': 'إعداد التدريب',
  'Which costs belong to a course, and how the course reaches Xero.':
    'أي التكاليف تخص دورة، وكيف تصل الدورة إلى Xero.',
  'How Xero knows which course': 'كيف يعرف Xero الدورة',
  'Xero could not be read just now, so this is not known.':
    'تعذّرت قراءة Xero الآن، لذا هذا غير معروف.',
  'Nothing has been set up yet. The first course invoiced will create it.':
    'لم يُعدّ شيء بعد. أول دورة تُفوتر ستنشئه.',
  'Tracking category slots free in Xero': 'خانات تصنيفات التتبّع المتاحة في Xero',
  'Every invoice and bill is stamped with its course, so Xero can split its own profit and loss by it.':
    'تُوسم كل فاتورة مبيعات ومشتريات بدورتها، ليتمكّن Xero من تقسيم قائمة أرباحه وخسائره حسبها.',
  'Tracking category': 'تصنيف التتبّع',
  'Courses in it': 'الدورات فيه',
  'full. Archive a finished course before adding another.':
    'ممتلئ. أرشِف دورة منتهية قبل إضافة أخرى.',
  'nearly full. Archive the courses that are finished and paid.':
    'شارف على الامتلاء. أرشِف الدورات المنتهية والمسدّدة.',
  'Accounts that carry a course cost': 'الحسابات التي تحمل تكلفة دورة',
  'Tick the accounts a training cost is posted to — trainer fees, materials, venue, catering. Rent, software and the audit fee are not course costs and should stay unticked.':
    'حدّد الحسابات التي تُقيَّد عليها تكاليف التدريب — أتعاب المدرّبين والمواد والقاعة والضيافة. الإيجار والبرمجيات وأتعاب التدقيق ليست تكاليف دورة وتبقى دون تحديد.',
  'A bill on a ticked account that is not on a course is listed below. Tick nothing and nothing is listed.':
    'أي فاتورة مشتريات على حساب محدَّد وغير مرتبطة بدورة تظهر أدناه. إن لم تحدّد شيئاً فلن يظهر شيء.',
  'No expense accounts were found in Xero.': 'لم يُعثر على حسابات مصروفات في Xero.',
  'Course costs not on a course': 'تكاليف دورات غير مرتبطة بدورة',
  'Tick some accounts above and anything missed will be listed here.':
    'حدّد بعض الحسابات أعلاه وسيظهر هنا ما فات ربطه.',
  'Xero could not be read just now, so nothing can be checked.':
    'تعذّرت قراءة Xero الآن، لذا لا يمكن التحقّق من شيء.',
  'Nothing is missing. Every bill on those accounts is on a course.':
    'لا ينقص شيء. كل فاتورة على تلك الحسابات مرتبطة بدورة.',
  'Only the most recent bills were checked. Older ones are not in this list.':
    'جرى فحص أحدث الفواتير فقط. الأقدم منها ليست في هذه القائمة.',

  'What this client has': 'ما مُنح لهذا العميل',
  /* 'Training' is already above, with the navigation. */
  'Courses, cohorts, student invoicing and what each course made. Nothing in Xero changes.':
    'الدورات والانعقادات وفوترة المتدرّبين وما حققته كل دورة. لا يتغيّر شيء في Xero.',
  'Xero Projects': 'مشاريع Xero',
  'Asks this client for the Projects permission in Xero, which lets trainer hours be costed to a course. Training works without it.':
    'يطلب من هذا العميل صلاحية المشاريع في Xero، وهي التي تتيح تحميل ساعات المدرّب على الدورة. التدريب يعمل بدونها.',
  'This asks the client to connect Xero again, so they can approve the new permission. Turn it on?':
    'سيتطلب ذلك من العميل إعادة ربط Xero للموافقة على الصلاحية الجديدة. هل تريد تفعيلها؟',
  'This connection has not been granted everything this client is now set up for. Reconnecting asks Xero for it.':
    'لم تُمنح هذه الصلة كل ما أصبح هذا العميل مهيّأً له. إعادة الربط تطلبه من Xero.',
  'on': 'مُفعّل',
  'off': 'غير مُفعّل',
  'Turn it on': 'تفعيلها',
  'Give them the Training section': 'منحهم قسم التدريب',
  'Ask for Xero Projects as well': 'طلب صلاحية مشاريع Xero أيضاً',
  'Projects appears on the consent screen they are about to read.':
    'ستظهر المشاريع في شاشة الموافقة التي سيقرأونها.',
  'Permissions this connection was granted': 'الصلاحيات الممنوحة لهذا الاتصال',
  'Not recorded — this connection was made before we kept track. Reconnect to find out.': 'غير مسجّلة — أُنشئ هذا الاتصال قبل أن نتتبّعها. أعد الربط لمعرفتها.',
  'Not known': 'غير معروف',
  'Valid': 'صالح',
  'expires in': 'ينتهي خلال',
  'minutes': 'دقيقة',
  'Expired — it will be renewed on the next request': 'منتهٍ — سيُجدَّد عند الطلب التالي',
  'Last renewed': 'آخر تجديد',
  'days left of the': 'يوماً متبقياً من',
  'Never — still on its first token': 'لم يحدث — ما زال على رمزه الأول',
  'Against an approved invoice. A draft cannot be paid — it is not a debt yet.': 'مقابل فاتورة معتمدة. المسودة لا يمكن سدادها — فهي ليست ديناً بعد.',
  'Payment': 'الدفعة',
  'No approved invoices are awaiting payment': 'لا توجد فواتير معتمدة بانتظار السداد',
  'to pay': 'مستحقة عليك',
  'owed to you': 'مستحقة لك',
  'Still outstanding': 'المتبقي',
  'of': 'من',
  'Paid into': 'مودعة في',
  'No account in Xero can receive payments': 'لا يوجد حساب في Xero يمكنه استلام الدفعات',
  'Date paid': 'تاريخ السداد',
  'That is more than this invoice still owes.': 'هذا أكثر من المتبقي على هذه الفاتورة.',
  'Xero will refuse it, or record a credit you did not mean to create.': 'سترفضه Xero، أو تسجّل رصيداً دائناً لم تقصد إنشاءه.',
  'optional': 'اختياري',
  'Bank transfer number, cheque number': 'رقم الحوالة أو رقم الشيك',
  'Recording…': 'جارٍ التسجيل…',
  'Record the payment': 'تسجيل الدفعة',
  'This is recorded in Xero straight away. A payment has no draft to approve.': 'يُسجَّل في Xero فوراً. الدفعة ليس لها مسودة تُعتمد.',
  'Recorded in Xero.': 'تم التسجيل في Xero.',
  'Xero could not be reached.': 'تعذّر الوصول إلى Xero.',
  'Taken from Xero. Drafts, voided and deleted documents are not counted.': 'مأخوذة من Xero. لا تُحتسب المسودات ولا المستندات الملغاة أو المحذوفة.',
  'This month': 'هذا الشهر',
  'Last month': 'الشهر الماضي',
  'This year': 'هذه السنة',
  'To': 'إلى',
  'Show': 'عرض',
  'Difference': 'الفرق',
  'Sales less purchases': 'المبيعات ناقص المشتريات',
  'Month by month': 'شهراً بشهر',
  'Best selling': 'الأكثر مبيعاً',
  'by value sold': 'حسب قيمة المبيعات',
  'Reading from Xero…': 'جارٍ القراءة من Xero…',
  'Nothing in this period.': 'لا يوجد شيء في هذه الفترة.',
  'Nothing sold in this period.': 'لم يُبع شيء في هذه الفترة.',
  'Not counted:': 'غير محتسب:',
  'drafts': 'مسودات',
  'voided or deleted': 'ملغاة أو محذوفة',
  'A draft is not a sale until somebody approves it.': 'المسودة ليست بيعاً حتى يعتمدها أحد.',
  'Xero could not be reached for this period. Try a shorter one.': 'تعذّر الوصول إلى Xero لهذه الفترة. جرّب فترة أقصر.',
  'This period holds more documents than can be read at once. The figures cover only part of it — choose a shorter period.': 'تحتوي هذه الفترة على مستندات أكثر مما يمكن قراءته دفعة واحدة. الأرقام تغطي جزءاً منها فقط — اختر فترة أقصر.',
  'January': 'يناير', 'February': 'فبراير', 'March': 'مارس', 'April': 'أبريل',
  'May': 'مايو', 'June': 'يونيو', 'July': 'يوليو', 'August': 'أغسطس',
  'September': 'سبتمبر', 'October': 'أكتوبر', 'November': 'نوفمبر', 'December': 'ديسمبر',
  'Send to Xero as': 'الإرسال إلى Xero بصيغة',
  'A draft to approve in Xero': 'مسودة تُعتمد في Xero',
  /* The date decides which period the revenue lands in, which is why it is
     offered rather than silently set to today. */
  'Invoice date': 'تاريخ الفاتورة',
  /* Left blank on purpose: the company's own Xero settings carry its
     payment terms, and an invoice sent without a due date takes them. */
  "blank = the company's own terms": 'فارغ = شروط السداد المسجّلة للشركة',
  'just this run': 'لهذه الدفعة فقط',
  'An approved document': 'مستند معتمد',
  'It waits in Xero until somebody approves it there.': 'ينتظر في Xero حتى يعتمده أحد هناك.',
  'It enters the ledger immediately and can be paid.': 'يدخل الدفاتر فوراً ويمكن سداده.',
  'File in Xero as approved': 'ترحيل إلى Xero كمعتمد',
  'Who can reach the books of': 'من يمكنه الوصول إلى دفاتر',
  'Access is granted by CFO Advisory and Accountancy and can be withdrawn at any time.': 'الوصول تمنحه CFO للاستشارات والمحاسبة ويمكن سحبه في أي وقت.',
  'Give someone access': 'منح شخص حق الوصول',
  'Email address': 'البريد الإلكتروني',
  'Role': 'الدور',
  'Give access': 'منح الوصول',
  'Has access': 'لديهم وصول',
  'Nobody has access to this organisation yet.': 'لا أحد لديه وصول إلى هذه المؤسسة بعد.',
  'Invited — has not signed in yet': 'تمت الدعوة — لم يسجّل الدخول بعد',
  'Since': 'منذ',
  'Remove': 'إزالة',
  'Withdraw': 'سحب الدعوة',
  'Unnamed': 'بدون اسم',
  'They do not need an account yet. The next time this address signs in, the access is already waiting.': 'لا يحتاجون إلى حساب بعد. في المرة القادمة التي يسجّل فيها هذا البريد الدخول، سيكون الوصول بانتظاره.',
  'Everything, including managing who has access': 'كل شيء، بما في ذلك إدارة من لديه وصول',
  'Reviews and files documents into Xero': 'يراجع المستندات ويرحّلها إلى Xero',
  'Prepares documents and submits them for review': 'يجهّز المستندات ويرسلها للمراجعة',
  'That does not look like an email address.': 'هذا لا يبدو بريداً إلكترونياً.',
  'That person already has access to this organisation.': 'هذا الشخص لديه وصول إلى هذه المؤسسة بالفعل.',
  'That address has already been invited.': 'تمت دعوة هذا البريد بالفعل.',
  'You cannot grant that role.': 'لا يمكنك منح هذا الدور.',
  'That did not work. Please try again.': 'لم ينجح ذلك. حاول مرة أخرى.',
  'Your own view': 'عرضك أنت',
  'See what a client sees. Changes nothing.': 'شاهد ما يراه العميل. لا يغيّر شيئاً.',
  'Xero did not accept this document': 'لم تقبل Xero هذا المستند',
  'Nothing was saved. Correct the document and try again.': 'لم يُحفظ شيء. صحّح المستند وحاول مرة أخرى.',
  'No contacts in Xero for this organisation yet': 'لا توجد جهات اتصال في Xero لهذه المؤسسة بعد',
  'No accounts found in Xero': 'لا توجد حسابات في Xero',
  'No tax rates found in Xero': 'لا توجد نسب ضريبية في Xero',
  'No currencies found in Xero': 'لا توجد عملات في Xero',
  'Nothing to choose from': 'لا يوجد ما يمكن اختياره',
  'Connect an organisation': 'ربط مؤسسة',
  'Connecting takes you to Xero to sign in and choose one organisation. Xero returns you here, and the connection is stored encrypted before anything else happens.':
    'يأخذك الربط إلى Xero لتسجيل الدخول واختيار مؤسسة واحدة. تعيدك Xero إلى هنا، ويُحفظ الاتصال مشفّراً قبل أي خطوة أخرى.',
  'One Xero connection per client organisation. Refresh tokens rotate on every use and die after 60 days of inactivity.':
    'اتصال واحد بـ Xero لكل مؤسسة عميل. رموز التحديث تُستبدل مع كل استخدام وتنتهي بعد 60 يوماً من الخمول.',
  'connections need attention': 'اتصالات تحتاج إلى متابعة',
  Healthy: 'سليم',
  'Expiring soon': 'قارب على الانتهاء',
  'Refresh failed': 'فشل التحديث',
  'Re-authorise': 'إعادة التفويض',
  'Connected clients': 'العملاء المتصلون',
  'Live in the practice account': 'نشطون في حساب المكتب',
  'Refreshed in the last 24 hours': 'تم التحديث خلال 24 ساعة',
  'Inside 14-day warning': 'داخل تحذير 14 يوماً',
  'Token window closing': 'نافذة الرمز تقترب من الإغلاق',
  Broken: 'معطّل',
  'Client must re-authorise': 'على العميل إعادة التفويض',
  'Per-client status': 'الحالة لكل عميل',
  'Token age is measured against the 60-day inactivity window':
    'عمر الرمز محسوب على نافذة الخمول 60 يوماً',
  'Send re-auth link': 'إرسال رابط إعادة التفويض',
  'Read from the connection table, not from Xero. Application Insights raises an alert at 14 days remaining and on any failed refresh.':
    'تُقرأ من جدول الاتصالات، لا من Xero. تُصدر Application Insights تنبيهاً عند بقاء 14 يوماً وعند أي فشل في التحديث.',
  Client: 'العميل',
  Status: 'الحالة',
  'Last successful sync': 'آخر مزامنة ناجحة',
  'Refresh token age': 'عمر رمز التحديث',
  Users: 'المستخدمون',
  users: 'مستخدمون',
  Today: 'اليوم',
  'days left in the window': 'يوماً متبقياً في النافذة',
  'Window closed — re-authorisation required': 'انتهت النافذة — إعادة التفويض مطلوبة',
  'QAR · financial year to 31 December 2026': 'ريال قطري · السنة المالية حتى 31 ديسمبر 2026',
  'QAR · your submissions': 'ريال قطري · مستنداتك المرسلة',
  'Draft created in Xero': 'أُنشئت مسودة في Xero',
  User: 'مستخدم',
  'CFO · Admin': 'المدير المالي · إدارة',
  'Data entry': 'إدخال البيانات',
  'CFO · Staff': 'المدير المالي · الفريق',
  'Organisation admin': 'مسؤول المؤسسة',
  'Signed in': 'مسجّل الدخول',
  'Submit for review': 'إرسال للمراجعة',
  'Submitted for review — finance will push it to Xero.':
    'تم الإرسال للمراجعة — سيقوم قسم المالية بدفعه إلى Xero.',
  'Submitted today': 'المرسل اليوم',
  '4 invoices · 2 bills': '4 فواتير مبيعات · 2 فواتير مشتريات',
  'Waiting on finance': 'بانتظار المالية',
  'Under review': 'قيد المراجعة',
  'Sent back to me': 'أُعيد إليّ',
  'Needs a correction': 'يحتاج تصحيحاً',
  Open: 'فتح',
  Retry: 'إعادة المحاولة',
  'Read this record from Xero': 'قراءة هذا السجل من Xero',

  'Recent submissions': 'أحدث المستندات المرسلة',
  'View all': 'عرض الكل',
  'Xero reference data': 'البيانات المرجعية من Xero',
  'Re-sync now': 'إعادة المزامنة الآن',
  'Cached 14 minutes ago': 'محفوظة مؤقتاً قبل 14 دقيقة',
  'Pushed to Xero today': 'أُرسلت إلى Xero اليوم',
  '9 invoices · 3 bills': '9 فواتير مبيعات · 3 فواتير مشتريات',
  'Waiting in the queue': 'في قائمة الانتظار',
  '1 blocked · 1 needs review': '1 محجوب · 1 يحتاج مراجعة',
  'Failed pushes': 'عمليات إرسال فاشلة',
  '1 validation · 1 rate limit': '1 خطأ تحقق · 1 تجاوز للحد',
  'Duplicates caught': 'تكرارات تم رصدها',
  'Checked before create': 'يُتحقق منها قبل الإنشاء',
  Contacts: 'جهات الاتصال',
  Accounts: 'الحسابات',
  'Tax rates': 'نسب الضريبة',
  Items: 'المنتجات',
  Currencies: 'العملات',
  'Tracking categories': 'فئات التتبع',
  'Statuses are read one record at a time when you refresh a row — nothing is mirrored in the background.':
    'تُقرأ الحالات سجلاً واحداً في كل مرة عند تحديث السطر — لا تتم أي مزامنة في الخلفية.',
  'Xero status is read one record at a time — press ↻ on a row.':
    'تُقرأ حالة Xero سجلاً واحداً في كل مرة — اضغط ↻ على السطر.',

  Number: 'الرقم',
  Date: 'التاريخ',
  Due: 'الاستحقاق',
  Ref: 'المرجع',
  From: 'من',
  Title: 'العنوان',
  Issued: 'تاريخ الإصدار',
  Expires: 'تاريخ الانتهاء',
  Order: 'أمر الشراء',
  Supplier: 'المورد',
  Delivery: 'التسليم',
  'Contact name': 'اسم جهة الاتصال',
  'Account no.': 'رقم الحساب',
  Email: 'البريد الإلكتروني',
  'Tax ID': 'الرقم الضريبي',
  Code: 'الرمز',
  Name: 'الاسم',
  Tracked: 'متتبع',
  Untracked: 'غير متتبع',
  'Cost price': 'سعر التكلفة',
  'Sale price': 'سعر البيع',
  'On hand': 'المتوفر',
  Location: 'الموقع',
  'Asset value': 'قيمة الأصل',
  Level: 'المستوى',
  'Reorder at': 'حد إعادة الطلب',
  'Days cover': 'أيام التغطية',
  Raised: 'تاريخ الإصدار',
  All: 'الكل',
  Draft: 'مسودة',
  Queued: 'في القائمة',
  'In Xero': 'في Xero',
  Failed: 'فاشل',
  'All locations': 'كل المواقع',
  'Central store': 'المخزن المركزي',
  'Needs attention': 'يحتاج انتباهاً',
  'rows submitted from this tool': 'سطر مُرسل من هذه الأداة',

  DRAFT: 'مسودة',
  'IN XERO': 'في XERO',
  FAILED: 'فاشل',
  REVIEW: 'مراجعة',
  QUEUED: 'في القائمة',
  READY: 'جاهز',
  BLOCKED: 'محجوب',
  OK: 'سليم',
  LOW: 'منخفض',
  REORDER: 'أعد الطلب',
  TRACKED: 'متتبع',
  UNTRACKED: 'غير متتبع',
  AUTHORISED: 'معتمد',
  CHECKING: 'جارٍ التحقق',
  PUSHED: 'مُرسل',

  Invoice: 'فاتورة مبيعات',
  Bill: 'فاتورة مشتريات',
  Quote: 'عرض سعر',
  'Purchase order': 'أمر شراء',
  'Documents held here are created in Xero as DRAFT, one API call each, with an Idempotency-Key per document.':
    'المستندات المحفوظة هنا تُنشأ في Xero كمسودة، باستدعاء واحد لكل مستند، مع مفتاح عدم تكرار لكل مستند.',
  Push: 'إرسال',
  documents: 'مستند',
  'Push selected': 'إرسال المحدد',
  'document(s) created in Xero as DRAFT — see the push log for the response.':
    'مستند أُنشئ في Xero كمسودة — راجع سجل الإرسال للاستجابة.',
  'The queue is empty. Documents you add from a form appear here until you push them.':
    'القائمة فارغة. المستندات التي تضيفها من النموذج تظهر هنا حتى ترسلها.',
  'All checks passed': 'كل الفحوصات ناجحة',
  'Failed pre-push checks': 'لم تنجح فحوصات ما قبل الإرسال',
  'Possible duplicate reference': 'مرجع مكرر محتمل',
  'Every call this tool made to Xero, with the response it came back with.':
    'كل استدعاء أجرته هذه الأداة إلى Xero، مع الاستجابة التي عادت به.',

  'Pre-push checks': 'فحوصات ما قبل الإرسال',
  'Ready to push': 'جاهز للإرسال',
  'blocking issues': 'مشكلة تمنع الإرسال',
  'Ready, with warnings': 'جاهز، مع تحذيرات',
  'Push to Xero as DRAFT': 'إرسال إلى Xero كمسودة',
  'Fix issues to push': 'أصلح المشكلات للإرسال',
  'Add to queue': 'إضافة إلى القائمة',
  'Import CSV / Excel': 'استيراد CSV / Excel',
  'Close import': 'إغلاق الاستيراد',
  Add: 'إضافة',
  lines: 'سطر',
  rates: 'نسبة',
  'Nothing to add yet': 'لا شيء لإضافته بعد',
  'Hide payload': 'إخفاء الحِزمة',
  'Show payload': 'عرض الحِزمة',
  'Xero payload preview': 'معاينة حِزمة Xero',
  'Sent by the backend, which owns the OAuth tokens. Created as DRAFT with an Idempotency-Key so a retry cannot duplicate.':
    'تُرسَل من الخدمة الخلفية التي تملك رموز OAuth. تُنشأ كمسودة مع مفتاح عدم تكرار حتى لا تؤدي إعادة المحاولة إلى نسخة مكررة.',
  'Description, Account and Tax Rate are required per line.':
    'الوصف والحساب ونسبة الضريبة مطلوبة لكل سطر.',
  'One line per row: description, qty, unit price [, account code, tax type]. Paste from Excel — tabs or commas both work.':
    'سطر لكل بند: الوصف، الكمية، سعر الوحدة [، رمز الحساب، نوع الضريبة]. الصق من Excel — تعمل علامات الجدولة والفواصل.',
  'On — stock valued': 'مفعّل — يُقيَّم المخزون',
  Off: 'معطّل',
  'No tax': 'بدون ضريبة',
  'Tax exclusive': 'غير شامل الضريبة',
  'Tax inclusive': 'شامل الضريبة',

  'Invoice details': 'بيانات الفاتورة',
  'Bill details': 'بيانات فاتورة المشتريات',
  'Quote details': 'بيانات عرض السعر',
  'Title, summary and terms': 'العنوان والملخص والشروط',
  'Order details': 'بيانات الأمر',
  'Contact details': 'بيانات جهة الاتصال',
  Addresses: 'العناوين',
  'Financial details': 'البيانات المالية',
  'Sales and purchase defaults': 'الإعدادات الافتراضية للمبيعات والمشتريات',
  Purchase: 'الشراء',
  Sell: 'البيع',
  'Due Date': 'تاريخ الاستحقاق',
  'Expiration date': 'تاريخ الانتهاء',
  'Quote number': 'رقم عرض السعر',
  Tax: 'الضريبة',
  Summary: 'الملخص',
  Terms: 'الشروط',
  'Date raised': 'تاريخ الإصدار',
  'Delivery date': 'تاريخ التسليم',
  'Order number': 'رقم أمر الشراء',
  'Delivery address': 'عنوان التسليم',
  Attention: 'لعناية',
  Telephone: 'الهاتف',
  'Delivery instructions': 'تعليمات التسليم',
  'Account number': 'رقم الحساب',
  'First name': 'الاسم الأول',
  'Last name': 'اسم العائلة',
  Phone: 'الهاتف',
  'Street address': 'عنوان الشارع',
  'Postal address': 'العنوان البريدي',
  City: 'المدينة',
  Region: 'المنطقة',
  Postcode: 'الرمز البريدي',
  Country: 'الدولة',
  'Bank account number': 'رقم الحساب البنكي',
  'Tax ID number': 'الرقم الضريبي',
  'Sales default account': 'حساب المبيعات الافتراضي',
  'Sales tax': 'ضريبة المبيعات',
  'Purchases default account': 'حساب المشتريات الافتراضي',
  'Purchase tax': 'ضريبة المشتريات',
  'Track inventory item': 'تتبع المخزون',
  'Inventory asset account': 'حساب أصول المخزون',
  'Purchase account': 'حساب المشتريات',
  'Tax rate': 'نسبة الضريبة',
  'Sales account': 'حساب المبيعات',
  auto: 'تلقائي',
  "Supplier's own invoice number": 'رقم فاتورة المورد الخاص',
  'Up to 500 characters': 'حتى 500 حرف',
  'Must be unique in the organisation': 'يجب أن يكون فريداً في المؤسسة',
  'Unique item code': 'رمز منتج فريد',
  'Text used on bills and purchase orders': 'نص يُستخدم في فواتير المشتريات وأوامر الشراء',
  'Text used on invoices and quotes': 'نص يُستخدم في الفواتير وعروض الأسعار',

  'Contact resolved to a ContactID': 'تم ربط جهة الاتصال بمعرّف ContactID',
  'No contact selected': 'لم تُحدد جهة اتصال',
  'Contact name is present and unique': 'اسم جهة الاتصال موجود وفريد',
  'No contact name entered': 'لم يُدخل اسم جهة اتصال',
  'Item code is present': 'رمز المنتج موجود',
  'No item code entered': 'لم يُدخل رمز منتج',
  'Every line has a Description': 'كل سطر يحتوي وصفاً',
  'Every line has an AccountCode': 'كل سطر يحتوي رمز حساب',
  'line(s) missing': 'سطر ناقص',
  'From the chart of accounts': 'من دليل الحسابات',
  'Tax types valid for the org': 'أنواع الضريبة صالحة للمؤسسة',
  'Dates normalised to YYYY-MM-DD': 'التواريخ موحّدة بصيغة YYYY-MM-DD',
  'Arabic-Indic digits converted to Western': 'تحويل الأرقام العربية إلى الإنجليزية',
  'Arabic-Indic digits found and folded before mapping':
    'عُثر على أرقام عربية وحُوّلت قبل الربط',
  'Typed input is normalised; the interface displays Western digits throughout':
    'يُحوَّل ما يُكتَب من أرقام؛ والواجهة تعرض الأرقام الإنجليزية في كل الشاشات',
  'Duplicate check against Xero': 'فحص التكرار مقابل Xero',
  'already exists in Xero': 'موجود مسبقاً في Xero',
  'No match for': 'لا يوجد تطابق لـ',
  'No reference entered — skipped': 'لم يُدخل مرجع — تم التخطي',

  'One connection, read and write. The backend owns the OAuth 2.0 tokens; reads happen on demand, never as a background sync.':
    'اتصال واحد للقراءة والكتابة. الخدمة الخلفية تملك رموز OAuth 2.0؛ تحدث القراءات عند الطلب، وليس كمزامنة خلفية.',
  Connection: 'الاتصال',
  'Granted scopes': 'الصلاحيات الممنوحة',
  Organisation: 'المؤسسة',
  'Access token': 'رمز الوصول',
  'Refresh token': 'رمز التحديث',
  'Create mode': 'وضع الإنشاء',
  'Reads performed': 'عمليات القراءة',
  'Background sync': 'المزامنة الخلفية',
  'Valid · expires in 27 minutes': 'صالح · ينتهي بعد 27 دقيقة',
  'Rotated on every refresh · 60-day inactivity window':
    'يُستبدل مع كل تحديث · نافذة خمول 60 يوماً',
  'DRAFT only, with Idempotency-Key per submission': 'مسودة فقط، مع مفتاح عدم تكرار لكل إرسال',
  'Reference data cache · single-record status refresh · duplicate search':
    'ذاكرة البيانات المرجعية · تحديث حالة سجل واحد · بحث التكرار',
  'None — no mirrored copy of the ledger': 'لا شيء — لا نسخة مطابقة من الدفاتر',

  'Outstanding balance': 'الرصيد المستحق',
  'Last document from here': 'آخر مستند لهذه الجهة',
  'Default currency': 'العملة الافتراضية',
  'Sales tax default': 'ضريبة المبيعات الافتراضية',
  'Tax on sales (5%)': 'ضريبة على المبيعات (5%)',
  'Tax on purchases (5%)': 'ضريبة على المشتريات (5%)',
  'Tax exempt (0%)': 'معفى من الضريبة (0%)',
  'Fetched just now, on this click only — not polled.':
    'تم جلبها الآن، بهذه النقرة فقط — دون استعلام دوري.',
  'This module is outside the Sales, Purchases and Contacts scope of the current build. The navigation is here so the shell matches the live app.':
    'هذه الوحدة خارج نطاق المبيعات والمشتريات وجهات الاتصال في هذا الإصدار. التنقل موجود ليطابق هيكل التطبيق الفعلي.',
  Sales_account_200: 'المبيعات',
  'Other revenue': 'إيرادات أخرى',
  'Cost of goods sold': 'تكلفة المبيعات',
  Advertising: 'الدعاية والإعلان',
  'General expenses': 'مصروفات عامة',
  'Kitchen consumables': 'مستهلكات المطبخ',
// Sign-in screens, from design/CFOAI Access.dc.html.
  /* The product name is artwork now and is not translated — the lockup
     has no Arabic form. See client/src/brand.ts. */
  "CFO Advisory and Accountancy": "CFO للاستشارات والمحاسبة",
  "Your books made easy for you": "دفاترك بين يديك بكل سهولة",
  "Sign in": "تسجيل الدخول",
  "You will be taken to a Microsoft sign-in page to enter your email and password. Your password is never typed into this portal. Once you are signed in, Microsoft brings you straight back here.":
    "سيتم تحويلك إلى صفحة تسجيل دخول من مايكروسوفت لإدخال بريدك وكلمة المرور. كلمة المرور لا تُكتب أبداً في هذه البوابة. وبعد تسجيل الدخول تعيدك مايكروسوفت إلى هنا مباشرة.",
  "Arabic first": "العربية أولاً",
  "Every screen, term and document is written in Arabic. English appears only where a figure or code has to stay as Xero records it.":
    "كل شاشة ومصطلح ومستند مكتوب بالعربية. ولا تظهر الإنجليزية إلا حيث يجب أن يبقى رقم أو رمز كما تسجله Xero.",
  "Your organisation only": "مؤسستك وحدها",
  "You see the records of your own organisation. Access is granted by your accountant and can be withdrawn at any time.":
    "ترى سجلات مؤسستك أنت فقط. الوصول يمنحه محاسبك ويمكن سحبه في أي وقت.",
  "Nothing is filed without review": "لا يُرحَّل شيء دون مراجعة",
  "Anything you submit reaches CFO Advisory and Accountancy as a draft. It is checked before it is posted to your books.":
    "كل ما ترسله يصل إلى CFO للاستشارات والمحاسبة كمسودة. تُراجع قبل ترحيلها إلى دفاترك.",
  "You are signed out": "تم تسجيل خروجك",
  "Your session on this device has ended and nothing further can be reached without signing in again.":
    "انتهت جلستك على هذا الجهاز، ولا يمكن الوصول إلى أي شيء دون تسجيل الدخول مرة أخرى.",
  "Sign in again": "تسجيل الدخول مرة أخرى",
  "Sign-in could not be completed": "لم يكتمل تسجيل الدخول",
  "You were not signed in. This usually means the Microsoft window was closed early, or the password was entered differently than expected. Nothing has changed on your account.":
    "لم يتم تسجيل دخولك. غالباً ما يعني هذا أن نافذة مايكروسوفت أُغلقت مبكراً، أو أن كلمة المرور أُدخلت بشكل مختلف. لم يتغير شيء في حسابك.",
  "Try again": "المحاولة مرة أخرى",
  "Your records cannot be reached right now": "تعذّر الوصول إلى سجلاتك الآن",
  "You are signed in correctly. The part of the service that holds your records is not answering. This is not a problem with your account, and nothing you have entered has been lost.":
    "تم تسجيل دخولك بشكل صحيح. الجزء الذي يحتفظ بسجلاتك لا يستجيب حالياً. لا توجد مشكلة في حسابك، ولم يُفقد أي شيء أدخلته.",
  "If it is still not working in a few minutes, tell CFO Advisory and Accountancy:":
    "إذا استمر الأمر بعد بضع دقائق، أبلغ CFO للاستشارات والمحاسبة:",
  "If it keeps happening, write to CFO Advisory and Accountancy and we will look into it with you:":
    "إذا تكرر الأمر، راسل CFO للاستشارات والمحاسبة وسننظر فيه معك:",
  'Footer on printed documents': 'التذييل في المستندات المطبوعة',
  "The company's own contact details, as its customers should see them. Leave a field empty and it is left off the page.":
    'بيانات الاتصال الخاصة بالشركة كما يراها عملاؤها. أي حقل يُترك فارغاً لا يظهر في الصفحة.',
  'Address': 'العنوان',
  'Street, area, city, country': 'الشارع، المنطقة، المدينة، الدولة',
  'Save': 'حفظ',
  'Saved': 'تم الحفظ',
  'Layout of printed documents': 'تنسيق المستندات المطبوعة',
  'Layout': 'التنسيق',
  'Plain bilingual sheet': 'صفحة ثنائية اللغة',
  "The company's own design": 'التصميم الخاص بالشركة',
  'A coloured band across the head and foot, the slogan beside the logo, and bank details under the totals.':
    'شريط ملوّن أعلى الصفحة وأسفلها، والشعار النصي بجانب الشعار، وبيانات البنك تحت الإجماليات.',
  'Slogan (Arabic)': 'الشعار النصي (عربي)',
  'Slogan (English)': 'الشعار النصي (إنجليزي)',
  'Accent colour': 'اللون الأساسي',
  'Band colour': 'لون الشريط',
  'Bank details, as they should appear on the invoice': 'بيانات البنك كما ينبغي أن تظهر في الفاتورة',
  'Account name': 'اسم الحساب',
  'IBAN': 'الآيبان',
  'Terms and conditions': 'الشروط والأحكام',
  'A colour has to be written as #rrggbb, for example #9b2242.':
    'يجب كتابة اللون بالصيغة ‎#rrggbb، مثل ‎#9b2242.',
  'Save changes': 'حفظ التغييرات',
  'Saving…': 'جارٍ الحفظ…',
  'Not saved yet.': 'لم يُحفظ بعد.',
  'Saved.': 'تم الحفظ.',
  'Everything here is saved.': 'كل ما هنا محفوظ.',
  'Payment methods': 'طرق الدفع',
  'The ways this company is paid. These are what the payment form offers.': 'طرق استلام المدفوعات لهذه الشركة. هذه ما يعرضه نموذج تسجيل الدفعة.',
  'Xero has no field for how a payment arrived, so this is kept here and written into the reference Xero is given.': 'لا يوجد في Xero حقل لطريقة استلام الدفعة، لذلك تُحفظ هنا وتُكتب ضمن المرجع المُرسل إلى Xero.',
  'Usual': 'المعتاد',
  'Choose at least one way of being paid.': 'اختر طريقة واحدة على الأقل لاستلام المدفوعات.',
  'How it was paid': 'طريقة الدفع',
  'Xero will show this as': 'سيظهر في Xero هكذا',
  'No ways of paying have been set for this company. Admin → Payment methods.': 'لم تُحدَّد طرق دفع لهذه الشركة. الإدارة ← طرق الدفع.',
  'Make a payment': 'تسجيل دفعة',
  'Paid from': 'مدفوعة من',
  'Choose an account': 'اختر حساباً',
  'That is more than is outstanding.': 'المبلغ أكبر من المتبقي.',
  'Paid in full.': 'تم السداد بالكامل.',
  'Xero PDF': 'ملف Xero',
  'Unit price': 'سعر الوحدة',
  '→ Back': 'رجوع ←',
  'Paid': 'مدفوعة',
  'Import': 'استيراد',
  'Import contacts': 'استيراد جهات الاتصال',
  'A spreadsheet of customers or suppliers. Nothing is sent to Xero until you have seen what was understood.': 'جدول بالعملاء أو المورّدين. لا يُرسل شيء إلى Xero قبل أن تطّلع على ما تم فهمه.',
  'Excel (.xlsx) or CSV. Excel is safer for Arabic: saving a CSV from Excel on an Arabic machine can change the encoding and the names arrive unreadable.': 'ملف Excel‏ (.xlsx) أو CSV. ملف Excel أأمن للعربية: حفظ CSV من Excel على جهاز عربي قد يغيّر الترميز فتصل الأسماء غير مقروءة.',
  'Xero decides whether a contact is a customer or a supplier, from whether it has an invoice or a bill. Both lists import the same thing.': 'يحدّد Xero إن كانت جهة الاتصال عميلاً أو مورّداً بحسب وجود فاتورة مبيعات أو مشتريات لها. كلا القائمتين تستورد الشيء نفسه.',
  'Reading…': 'جارٍ القراءة…',
  'Choose a file': 'اختر ملفاً',
  'Download a template': 'تنزيل نموذج',
  "This file was saved in the Arabic Windows encoding, not Unicode. The names below have been converted — check them. If any look wrong, re-save from Excel as \"CSV UTF-8\" or as .xlsx.": 'حُفظ هذا الملف بترميز ويندوز العربي لا بترميز يونيكود. جرت تحويل الأسماء أدناه — راجعها. إن بدا أي منها خاطئاً، أعد الحفظ من Excel بصيغة ‎"CSV UTF-8"‎ أو ‎.xlsx‎.',
  'Which column is which': 'تحديد الأعمدة',
  '— not imported —': '— لا يُستورد —',
  'Column': 'عمود',
  'What will be imported': 'ما سيتم استيراده',
  'ready': 'جاهز',
  'will be skipped': 'سيتم تخطيها',
  'Line': 'السطر',
  'Ready': 'جاهز',
  'Sending…': 'جارٍ الإرسال…',
  'Skipped rows are left alone. Fix them in the file and import it again.': 'تُترك الأسطر المتخطاة كما هي. صحّحها في الملف ثم استورده مرة أخرى.',
  'contacts added to Xero.': 'جهة اتصال أُضيفت إلى Xero.',
  'were refused by Xero:': 'رُفضت من Xero:',
  'See the list': 'عرض القائمة',
  'No name': 'بدون اسم',
  'Listed twice in this file': 'مكرّرة في هذا الملف',
  'Already in Xero': 'موجودة في Xero',
  'Not an email address': 'ليس بريداً إلكترونياً',
  'Street': 'العنوان',
  'Tax number': 'الرقم الضريبي',
  'Bank account': 'الحساب البنكي',
  'That file is too large. The limit is 5 MB.': 'حجم الملف كبير. الحد الأقصى ٥ ميجابايت.',
  'That file could not be read. Save it as .xlsx or CSV and try again.': 'تعذّرت قراءة الملف. احفظه بصيغة ‎.xlsx‎ أو CSV وحاول مجدداً.',
  'That file has no rows under its headings.': 'لا توجد أسطر تحت عناوين الأعمدة في هذا الملف.',
  'That is more than 2000 rows. Split it and import in parts.': 'عدد الأسطر يتجاوز ٢٠٠٠. قسّم الملف واستورده على أجزاء.',
  'No column looks like a contact name. Add one called Name, or use the template.': 'لا يوجد عمود يبدو أنه اسم جهة الاتصال. أضف عموداً باسم Name أو استخدم النموذج.',
  'Waiting — no email is sent; they must sign in themselves': 'في الانتظار — لا يُرسَل بريد؛ عليهم تسجيل الدخول بأنفسهم',
  'Nothing is emailed.': 'لا يُرسَل أي بريد إلكتروني.',
  'Send them this address yourself and tell them to sign up with the same email you entered above.': 'أرسل لهم هذا الرابط بنفسك واطلب منهم التسجيل بالبريد نفسه الذي أدخلته أعلاه.',
  'Copy': 'نسخ',
  'Copied': 'تم النسخ',
  'Their name': 'الاسم',
  'An account is created for them straight away. The access is waiting the first time they sign in.': 'يُنشأ لهم حساب فوراً. ويكون الوصول بانتظارهم عند أول تسجيل دخول.',
  'No invitation is emailed.': 'لا تُرسَل دعوة بالبريد.',
  'Send them this address yourself. They choose "Forgot password?", enter the same email, and collect the code sent to it — that sets their password and signs them in.': 'أرسل لهم هذا الرابط بنفسك. يختارون «نسيت كلمة المرور؟»، ويُدخلون البريد نفسه، ويأخذون الرمز المُرسَل إليه — بذلك يضبطون كلمة المرور ويدخلون.',
  'Sign-in ready — waiting for them': 'الحساب جاهز — في انتظارهم',
  'Sign-in refused': 'رُفض إنشاء الحساب',
  'Sign-in not created yet': 'لم يُنشأ الحساب بعد',
  'No sign-in was made for this invitation': 'لم يُنشأ حساب لهذه الدعوة',
  'Create sign-in': 'إنشاء حساب الدخول',
  'The sign-in could not be created. Please try again.': 'تعذّر إنشاء حساب الدخول. حاول مرة أخرى.',
  'Choose a company': 'اختر مؤسسة',
  'You can reach more than one. Nothing is open until you choose.': 'لديك وصول إلى أكثر من مؤسسة. لن تُفتح أي مؤسسة حتى تختار واحدة.',
  'Customer': 'العميل',
  'Access can be withdrawn at any time.': 'يمكن سحب الوصول في أي وقت.',
  'Your accountant': 'محاسبك',
  'Only CFO Advisory and Accountancy can remove one of its own people.': 'لا يمكن إزالة أحد موظفي CFO للاستشارات والمحاسبة إلا من قِبلها.',
  'Files documents into Xero, and manages people and settings': 'يرحّل المستندات إلى Xero، ويدير الأشخاص والإعدادات',
  'Creates documents and files them into Xero': 'يُنشئ المستندات ويرحّلها إلى Xero',
  'Nothing filed yet today': 'لم يُرحَّل شيء اليوم بعد',
  'Not accepted by Xero': 'لم يقبلها Xero',
  'invoices': 'فواتير مبيعات',
  'bills': 'فواتير مشتريات',
  'blocked': 'محجوب',
  'needs review': 'يحتاج مراجعة',
  'Loading': 'جارٍ التحميل',
  'Not loaded yet': 'لم تُحمَّل بعد',
  'Cached just now': 'محفوظة مؤقتاً الآن',
  'Cached 1 minute ago': 'محفوظة مؤقتاً قبل دقيقة',
  'Cached': 'محفوظة مؤقتاً قبل',
  'minutes ago': 'دقيقة',
  'rows from Xero': 'سطر من Xero',
  'Overdue': 'متأخرة',
  'Awaiting payment': 'بانتظار السداد',
  'Awaiting approval': 'بانتظار الاعتماد',
  'Outstanding': 'المتبقي',
  'AWAITING PAYMENT': 'بانتظار السداد',
  'AWAITING APPROVAL': 'بانتظار الاعتماد',
  'OVERDUE': 'متأخرة',
  'PAID': 'مدفوعة',
  'VOIDED': 'ملغاة',
  'Amount paid': 'المدفوع',
  'Part payment.': 'سداد جزئي.',
  'will still be owed on this invoice.': 'سيبقى مستحقاً على هذه الفاتورة.',
  'Part paid': 'مدفوعة جزئياً',
  'PART PAID': 'مدفوعة جزئياً',
  'Refresh': 'تحديث',
  'Reading Xero…': 'جارٍ القراءة من Xero…',
  'Reconnect needed': 'يلزم إعادة الربط',
  'Record payment': 'تسجيل الدفعة',
  'Amount due': 'المبلغ المستحق',
  'Our own bilingual layout, with the branding set in this product': 'تنسيقنا ثنائي اللغة، بالهوية المضبوطة في هذا النظام',
  'The layout Xero makes, not the branding set here': 'التنسيق الذي ينشئه Xero، وليس الهوية المضبوطة هنا',

  /* Money in and out: spending, receiving and transferring. */
  'Money in and out': 'الحركات النقدية',
  'Against an invoice': 'مقابل فاتورة',
  'Spend money': 'صرف مبلغ',
  'Receive money': 'استلام مبلغ',
  'Transfer money': 'تحويل بين الحسابات',
  'Money leaving a bank account with no bill behind it — a charge, a receipt, a direct purchase.':
    'مبلغ يخرج من حساب بنكي دون فاتورة مشتريات خلفه — رسوم أو إيصال أو شراء مباشر.',
  'Money arriving with no invoice behind it — a cash sale, interest, a refund.':
    'مبلغ يصل دون فاتورة مبيعات خلفه — بيع نقدي أو فائدة أو مبلغ مُعاد.',
  'Money moving between two of your own accounts. Nothing is spent and nothing is earned.':
    'مبلغ ينتقل بين حسابين من حساباتكم. لا صرف ولا إيراد.',
  'Money out': 'مبلغ خارج',
  'Money in': 'مبلغ وارد',
  /* 'Paid from' is already above, shared with the bill payment on a document. */
  'Received into': 'مودع في',
  'Paid to': 'مدفوع إلى',
  'Received from': 'مستلم من',
  'Category': 'التصنيف',
  'Account default': 'الافتراضي للحساب',
  'What was bought': 'ما الذي تم شراؤه',
  'What it was for': 'سبب الاستلام',
  'No bank account in Xero for this company': 'لا يوجد حساب بنكي في Xero لهذه المؤسسة',
  'Total out': 'إجمالي الصرف',
  'Total in': 'إجمالي الاستلام',
  'Every line with an amount needs a category.': 'كل سطر به مبلغ يحتاج إلى تصنيف.',
  'Record money out': 'تسجيل الصرف',
  'Record money in': 'تسجيل الاستلام',
  'This is recorded in Xero straight away. Money out and money in have no draft to approve.':
    'يُسجَّل في Xero مباشرة. الصرف والاستلام ليس لهما مسودة تُعتمد.',
  'Transfer': 'تحويل',
  'Out of': 'من حساب',
  'Into': 'إلى حساب',
  'A transfer needs two different accounts.': 'التحويل يحتاج إلى حسابين مختلفين.',
  'A transfer needs two bank accounts, and this company has one.':
    'التحويل يحتاج إلى حسابين بنكيين، ولهذه المؤسسة حساب واحد.',
  'leaves one of your accounts and arrives in the other. Nothing is spent.':
    'يخرج من أحد حساباتكم ويصل إلى الآخر. لم يُصرف شيء.',
  'Record the transfer': 'تسجيل التحويل',
  'Both sides are written in Xero at once. A transfer has no draft to approve.':
    'يُكتب طرفا التحويل في Xero معاً. التحويل ليس له مسودة تُعتمد.',
  'Enter an amount greater than zero.': 'أدخل مبلغاً أكبر من صفر.',
  'Nothing has been entered yet.': 'لم يُدخَل شيء بعد.',
  'That date could not be read.': 'تعذّرت قراءة هذا التاريخ.',
  'You are not allowed to record this for this company.':
    'لا تملك صلاحية تسجيل هذا لهذه المؤسسة.',


  /* Training: the catalogue, the runs, and who is on them. */
  'Training': 'التدريب',
  'Courses': 'الدورات',
  'Course': 'الدورة',
  'Training deliveries': 'الدورات المنعقدة',
  /* Not 'Delivery' — that key already means a shipment, التسليم, on the
     purchase order. A course session is a different word entirely. */
  'Training delivery': 'الانعقاد',
  'What you teach. One entry per course, however many times it runs.':
    'ما تقدّمونه من تدريب. مدخل واحد لكل دورة، مهما تكرر انعقادها.',
  'Every time a course actually runs. Open one to manage who is on it.':
    'كل مرة تنعقد فيها دورة فعلياً. افتح واحدة لإدارة المسجّلين فيها.',
  'Add a course': 'إضافة دورة',
  'Edit course': 'تعديل الدورة',
  'Course name': 'اسم الدورة',
  'Course name in Arabic': 'اسم الدورة بالعربية',
  'Usual fee per seat': 'الرسوم المعتادة للمقعد',
  'Usual fee': 'الرسوم المعتادة',
  'Still offered': 'ما زالت تُقدَّم',
  'no longer offered': 'لم تعد تُقدَّم',
  'Times run': 'مرات الانعقاد',
  'No courses yet. Add the first one above.': 'لا توجد دورات بعد. أضف الأولى أعلاه.',
  'Add a course first — a delivery is one run of a course.':
    'أضف دورة أولاً — الانعقاد هو مرة واحدة من انعقاد دورة.',

  'Schedule a delivery': 'جدولة انعقاد',
  'Edit delivery': 'تعديل الانعقاد',
  'What to call this run': 'اسم هذا الانعقاد',
  'IFRS update — November cohort': 'مستجدات المعايير — مجموعة نوفمبر',
  'Public course': 'دورة عامة',
  'Corporate booking': 'حجز مؤسسي',
  'Public': 'عامة',
  'Corporate': 'مؤسسي',
  'Starts': 'تبدأ',
  'Ends': 'تنتهي',
  'same day if blank': 'اليوم نفسه إذا تُرك فارغاً',
  'Trainer': 'المدرّب',
  'Venue': 'المكان',
  'Seats': 'المقاعد',
  'blank = no limit': 'فارغ = بلا حد',
  'blank = usual': 'فارغ = المعتاد',
  'Agreed contract fee': 'قيمة العقد المتفق عليها',
  'Dates': 'التواريخ',
  'On the course': 'في الدورة',
  'Planned': 'مخطط لها',
  'Running': 'جارية',
  'Finished': 'منتهية',
  'Upcoming': 'قادمة',
  'Running now': 'جارية الآن',
  'Nothing scheduled yet.': 'لا يوجد انعقاد مجدول بعد.',

  'All deliveries': 'كل الانعقادات',
  'Add a student': 'إضافة متدرّب',
  'Add an attendee': 'إضافة حاضر',
  'Edit booking': 'تعديل التسجيل',
  'Nobody is booked on this yet.': 'لا يوجد مسجّلون بعد.',
  'Expected revenue': 'الإيراد المتوقع',
  'the agreed contract fee': 'قيمة العقد المتفق عليها',
  'from live bookings': 'من التسجيلات القائمة',
  'Invoiced in Xero': 'مُفوتر في Xero',
  'seats billed so far': 'المقاعد المفوترة حتى الآن',
  'not counted in the total': 'غير محتسبة في الإجمالي',
  'full': 'ممتلئة',
  'no seat limit': 'بلا حد للمقاعد',
  'More bookings than seats.': 'التسجيلات أكثر من المقاعد.',
  'Nothing is blocked — this is here so it is not a surprise on the day.':
    'لم يُمنع شيء — هذا تنبيه فقط كي لا يكون مفاجأة يوم الانعقاد.',
  'These are bookings — what people agreed to pay. What the course actually earned is below.':
    'هذه تسجيلات — ما اتفق الناس على دفعه. أما ما حققته الدورة فعلياً فهو أدناه.',
  'Registered': 'مسجّل',
  'Cancelled': 'ملغاة',
  'Cancel': 'إلغاء الأمر',
  'Loading…': 'جارٍ التحميل…',
  'Edit': 'تعديل',
  'Type': 'النوع',
  'Fee': 'الرسوم',
  'Yes': 'نعم',
  'Attended': 'حضر',
  'Refunded': 'مُسترد',
  'Invoiced': 'مُفوتر',
  'Not yet': 'ليس بعد',
  'Discount': 'الخصم',

  'That could not be loaded. Please try again.': 'تعذّر التحميل. حاول مرة أخرى.',
  'That delivery could not be opened.': 'تعذّر فتح هذا الانعقاد.',
  'The end date is before the start date.': 'تاريخ الانتهاء قبل تاريخ البدء.',
  'That course no longer exists.': 'لم تعد هذه الدورة موجودة.',
  'That has been removed by somebody else.': 'قام شخص آخر بحذف هذا.',

  /* Billing a cohort. A student becomes a customer in Xero. */
  'Creating invoices…': 'جارٍ إنشاء الفواتير…',
  'Invoice the company': 'فوترة الشركة',
  'Invoice the cohort': 'فوترة المجموعة',

  /* What a course cost, what it made, and closing its books. */
  'Closed': 'مُقفلة',
  'Close this course': 'إقفال هذه الدورة',
  'Reopen this course': 'إعادة فتح هذه الدورة',
  'Nothing more can be added. The figures above are final unless it is reopened.':
    'لا يمكن إضافة شيء بعد الآن. الأرقام أعلاه نهائية ما لم يُعَد فتحها.',
  'Do this when every invoice is raised and every bill is in. Nothing more can be added here afterwards.':
    'افعل ذلك بعد إصدار كل الفواتير ووصول كل فواتير المشتريات. لن يمكن إضافة شيء هنا بعدها.',
  /* Closing locks this screen, not Xero. Saying otherwise would be a
     promise the product cannot keep. */
  'Xero itself stays open: an invoice or bill changed there will still change the figures above, because they are read from Xero every time.':
    'يبقى Xero مفتوحاً: أي تعديل على فاتورة هناك سيغيّر الأرقام أعلاه، لأنها تُقرأ من Xero في كل مرة.',

  'What this course cost': 'ما كلّفته هذه الدورة',
  'For a training course': 'لدورة تدريبية',
  'Product in Xero': 'المنتج في Xero',
  'Sell as a product': 'بيعها كمنتج',
  'Unlink': 'فك الربط',
  'The product stays in Xero; only the link goes.':
    'يبقى المنتج في Xero، ولا يُحذف سوى الربط.',
  'Give this course a code first — Xero needs one for a product.':
    'أضف رمزاً لهذه الدورة أولاً — يحتاج Xero إلى رمز للمنتج.',
  'Only an administrator can add a product to Xero.':
    'إضافة منتج إلى Xero من صلاحية المدير فقط.',
  'Not for a course': 'ليست لدورة',
  'No courses are open': 'لا توجد دورات مفتوحة',
  'Not sent to Xero': 'لا يُرسل إلى Xero',
  'Put a bill on this course': 'ربط فاتورة مشتريات بهذه الدورة',
  /* Two ways a cost arrives: filed here and linked automatically, or
     already in Xero and attached afterwards. */
  'New bill for this course': 'فاتورة مشتريات جديدة لهذه الدورة',
  'Attach one that exists': 'ربط فاتورة موجودة',
  'Bill or money out': 'فاتورة مشتريات أو مبلغ خارج',
  'Search your bills…': 'ابحث في فواتير المشتريات…',
  'No bills or money out found in Xero': 'لا توجد فواتير مشتريات أو مبالغ خارجة في Xero',
  'Share for this course': 'حصة هذه الدورة',
  'blank = all of it': 'فارغ = كامل المبلغ',
  'Note': 'ملاحظة',
  'Why only part of it, for example': 'سبب احتساب جزء منها، مثلاً',
  'Add the cost': 'إضافة التكلفة',
  '(already on another course)': '(مرتبطة بدورة أخرى)',
  'Nothing has been put on this course yet. Its costs will not appear until they are.':
    'لم يُربط شيء بهذه الدورة بعد. لن تظهر تكاليفها حتى تُربط.',
  'What': 'البند',
  'On this course': 'على هذه الدورة',
  'Xero no longer has this. It is not counted.': 'لم يعد Xero يحتوي على هذا. وهو غير محتسب.',
  /* One bill spread across more courses than it can pay for. A warning,
     never a refusal: the share may be right and the bill may be wrong. */
  'More has been put on courses than this bill is worth.':
    'المبالغ الموزّعة على الدورات تتجاوز قيمة هذه الفاتورة.',
  'Put on courses': 'الموزّع على الدورات',
  'The bill itself': 'قيمة الفاتورة',
  'Also on other courses': 'مرتبطة أيضاً بدورات أخرى',
  'Amounts exclude tax. The bill stays in Xero exactly as it is — this only says which course it belongs to.':
    'المبالغ غير شاملة الضريبة. تبقى الفاتورة في Xero كما هي — هذا يحدد فقط الدورة التي تخصها.',


  /* ---------------------------------------------------------------------
     Money given back. Only for the student refunded after paying in
     full — a credit note against an unpaid invoice is already counted
     on the invoice itself.
  --------------------------------------------------------------------- */
  'Money given back': 'المبالغ المُعادة',
  'Put a credit note on this course': 'ربط إشعار دائن بهذه الدورة',
  'Credit note': 'إشعار دائن',
  'Search your credit notes…': 'ابحث في الإشعارات الدائنة…',
  'No credit notes found in Xero': 'لا توجد إشعارات دائنة في Xero',
  'Add it': 'إضافته',
  'Nothing has been given back on this course.': 'لم يُعد أي مبلغ في هذه الدورة.',
  'A credit note against an unpaid invoice is counted on its own — this is only for a student refunded after paying in full.':
    'الإشعار الدائن المقابل لفاتورة غير مسدّدة يُحتسب تلقائياً — هذا القسم فقط لمتدرّب أُعيد له المبلغ بعد سداده كاملاً.',
  'Who': 'الجهة',
  'Off this course': 'يُخصم من هذه الدورة',
  'Part of it was already taken off an invoice here.': 'جزء منه خُصم أصلاً من فاتورة في هذه الدورة.',
  'This comes off what the course earned, not onto what it cost. Amounts exclude tax.':
    'يُخصم هذا مما حققته الدورة، لا يُضاف إلى ما كلّفته. المبالغ غير شاملة الضريبة.',

  'What this course made': 'ما حققته هذه الدورة',
  'Came in': 'الداخل',
  'Went out': 'الخارج',
  'Made': 'الربح',
  'Lost': 'الخسارة',
  'Per student': 'لكل متدرّب',
  'Lost per student': 'الخسارة لكل متدرّب',
  'margin': 'هامش',
  'nothing billed yet': 'لم تُصدر فواتير بعد',
  'invoice': 'فاتورة',
  /* 'invoices' is already above. */
  'cost': 'تكلفة',
  'costs': 'تكاليف',
  'Collected': 'المحصّل',
  /* Refunded on a credit note. Collected, given back and still to collect
     together account for the whole of what was invoiced. */
  'Given back': 'المرتجع',
  'Still to collect': 'المتبقي تحصيله',
  'Both sides exclude tax. Only the invoices and bills put on this course are counted.':
    'الطرفان غير شاملين الضريبة. تُحتسب فقط الفواتير المرتبطة بهذه الدورة.',
  'Salaries, rent and anything shared across the business are not here — those are in the profit and loss.':
    'الرواتب والإيجار وكل ما هو مشترك على مستوى المنشأة ليست هنا — مكانها قائمة الأرباح والخسائر.',
  'invoice is still a draft and is not counted.': 'فاتورة ما زالت مسودة وغير محتسبة.',
  'invoices are still drafts and are not counted.': 'فواتير ما زالت مسودات وغير محتسبة.',
  /* Xero leaves an invoice's SubTotal at its original value when a credit
     note is allocated to it, so what was handed back has to be taken off
     separately or the course looks more profitable than it was. */
  'invoice has a credit note against it, and what was given back has been taken off.':
    'فاتورة صدر إشعار دائن مقابلها، وقد خُصم ما أُعيد منها.',
  'invoices have credit notes against them, and what was given back has been taken off.':
    'فواتير صدرت إشعارات دائنة مقابلها، وقد خُصم ما أُعيد منها.',
  /* Mixed currencies are reported, never converted: Xero carries a rate
     but a silently inverted one is worse than an honest gap. */
  'Not counted, because they are in another currency:':
    'غير محتسبة لأنها بعملة أخرى:',
  'one document': 'مستند واحد',
  'Convert them in Xero, or keep this course in one currency.':
    'حوّلها في Xero، أو اجعل هذه الدورة بعملة واحدة.',
  'This course is closed. Reopen it to make changes.':
    'هذه الدورة مُقفلة. أعد فتحها لإجراء تغييرات.',
  'Only an administrator can close or reopen a course.':
    'الإقفال وإعادة الفتح من صلاحية المدير فقط.',
  'student': 'متدرّب',
  'students': 'متدرّبين',
  'Everything here has been invoiced.': 'تمت فوترة كل ما هنا.',
  'Add somebody to the course first.': 'أضف شخصاً إلى الدورة أولاً.',
  'Nobody here has a fee to bill.': 'لا أحد هنا عليه رسوم تُفوتر.',
  'Choose the company this corporate booking is for.': 'اختر الشركة صاحبة هذا الحجز المؤسسي.',
  'Enter the agreed contract fee for this corporate booking.':
    'أدخل قيمة العقد المتفق عليها لهذا الحجز المؤسسي.',
  'Each student becomes a customer in Xero. The invoices enter the ledger at once.':
    'يصبح كل متدرّب عميلاً في Xero. وتدخل الفواتير الدفاتر فوراً.',
  'Each student becomes a customer in Xero. The invoices wait there to be approved.':
    'يصبح كل متدرّب عميلاً في Xero. وتنتظر الفواتير هناك حتى تُعتمد.',
  'Bill to': 'الفاتورة على',
  'leave blank to bill the student': 'اتركه فارغاً لتُفوتر المتدرّب نفسه',
  'The company': 'الشركة',
  'The student themselves': 'المتدرّب نفسه',
  'Still owed': 'المتبقي',
  'still owed': 'متبقية',
  "The company's invoice": 'فاتورة الشركة',
  'Not raised yet': 'لم تُصدر بعد',
  'One invoice to the company for the agreed fee. It enters the ledger at once.':
    'فاتورة واحدة للشركة بقيمة العقد المتفق عليها. تدخل الدفاتر فوراً.',
  'One invoice to the company for the agreed fee. It waits in Xero to be approved.':
    'فاتورة واحدة للشركة بقيمة العقد المتفق عليها. تنتظر في Xero حتى تُعتمد.',
  'Open this invoice': 'فتح هذه الفاتورة',
  'View': 'عرض',
  /* Reports. Four of them: one from Xero, three worked out here. */
  'Reports': 'التقارير',
  /* The separator between the two date boxes on a report's period. */
  'to': 'إلى',
  'Profit and loss': 'الأرباح والخسائر',
  /* 'Sales tax' is already above, from the tax-rate settings. */
  'Aged receivables summary': 'ملخص أعمار الذمم المدينة',
  'Aged payables summary': 'ملخص أعمار الذمم الدائنة',
  'What the company earned and spent over a period. Prepared by Xero.':
    'ما حققته المؤسسة من إيرادات وما أنفقته خلال فترة. من إعداد Xero.',
  'Tax collected and tax paid, by rate. Worked out here, not by Xero.':
    'الضريبة المحصَّلة والمدفوعة، حسب النسبة. محسوبة هنا، وليست من Xero.',
  'Who owes this company money, and how late it is.':
    'من يدين لهذه المؤسسة بأموال، ومدى تأخره.',
  'Who this company owes, and how late it is.': 'لمن تدين هذه المؤسسة، ومدى التأخر.',
  'Prepared by Xero. These are its figures, shown unchanged.':
    'من إعداد Xero. هذه أرقامه، معروضة دون تغيير.',
  'Xero returned no figures for this period.': 'لم يُرجع Xero أي أرقام لهذه الفترة.',
  'Xero could not be reached for this report. Try a shorter period.':
    'تعذّر الوصول إلى Xero لهذا التقرير. جرّب فترة أقصر.',

  /* Aged summaries. */
  /* Charts, comparison and filters on the reports. */
  'Compare': 'مقارنة',
  'No comparison': 'بلا مقارنة',
  'Last 3 months': 'آخر ٣ أشهر',
  'Last 6 months': 'آخر ٦ أشهر',
  'Last 12 months': 'آخر ١٢ شهراً',
  'Narrow to one name…': 'تصفية باسم واحد…',
  'Narrow to a tax rate…': 'تصفية بنسبة ضريبية…',
  'Clear': 'مسح',
  'Nobody here matches that.': 'لا أحد هنا يطابق ذلك.',
  'How late it is': 'مدى التأخر في التحصيل',
  'How late we are': 'مدى تأخرنا في السداد',
  'By rate': 'حسب النسبة',
  'The bottom line': 'النتيجة النهائية',
  'Where the money went': 'أين ذهبت الأموال',
  'Nothing to show yet.': 'لا يوجد ما يُعرض بعد.',

  'Not due yet': 'غير مستحق بعد',
  '1–30 days': '١–٣٠ يوماً',
  '31–60 days': '٣١–٦٠ يوماً',
  '61–90 days': '٦١–٩٠ يوماً',
  'Over 90 days': 'أكثر من ٩٠ يوماً',
  'Vendor': 'المورّد',
  'As at': 'كما في',
  'from': 'من',
  'unpaid invoices': 'فاتورة مبيعات غير مسددة',
  'unpaid bills': 'فاتورة مشتريات غير مسددة',
  'No due date in Xero': 'بلا تاريخ استحقاق في Xero',
  'shown as not due yet': 'تظهر كغير مستحقة بعد',
  'Nobody owes this company anything right now.': 'لا أحد يدين لهذه المؤسسة بشيء حالياً.',
  'This company owes nothing right now.': 'لا تدين هذه المؤسسة بشيء حالياً.',
  'There were more documents than this could read. The total is partial.':
    'عدد المستندات أكبر مما يمكن قراءته. الإجمالي جزئي.',

  /* Sales tax. */
  'Tax collected on sales': 'الضريبة المحصَّلة على المبيعات',
  'Tax paid on purchases': 'الضريبة المدفوعة على المشتريات',
  'Net tax owed': 'صافي الضريبة المستحقة',
  'Net tax reclaimable': 'صافي الضريبة القابلة للاسترداد',
  'Net sales': 'صافي المبيعات',
  'Net purchases': 'صافي المشتريات',
  'Tax on sales': 'الضريبة على المبيعات',
  'Tax on purchases': 'الضريبة على المشتريات',
  'What this is, and what it is not': 'ما هذا التقرير، وما ليس هو',
  'Xero has no sales tax report in its API, so this is worked out from the documents in the period.':
    'لا يوفّر Xero تقرير ضريبة مبيعات في واجهته البرمجية، لذا يُحتسب هذا من مستندات الفترة.',
  'Accrual basis: a document counts on its date, not when it was paid. Manual journals are not included.':
    'أساس الاستحقاق: يُحتسب المستند بتاريخه لا بتاريخ سداده. القيود اليدوية غير مشمولة.',
  'Read': 'قُرئ',
  'documents.': 'مستنداً.',
  /* 'drafts' is already above. */
  'voided': 'ملغى',
  'were not counted.': 'لم تُحتسب.',
  'Check it against Xero before filing anything.':
    'راجعه مقابل Xero قبل تقديم أي إقرار.',

  /* ---- The opening screen, shown while the session is being fetched ---- */
  'One moment': 'لحظة من فضلك',
  'We are opening your books.': 'نفتح دفاترك الآن.',
  'The first sign-in of the day takes a little longer, because your records are being woken up.':
    'أول دخول في اليوم يستغرق وقتاً أطول قليلاً، لأن سجلاتك يجري إيقاظها.',
  'Still working. If this screen is still here in another minute, refresh the page.':
    'العمل ما زال جارياً. إذا بقيت هذه الشاشة دقيقة أخرى، فحدّث الصفحة.',

  'Xero could not be reached': 'تعذّر الوصول إلى Xero',

  /* ---- Settling a document straight after filing it ---- */
  'Payment type': 'نوع الدفعة',
  'Full payment': 'سداد كامل',
  'Part payment': 'سداد جزئي',
  'Outstanding before this': 'المستحق قبل هذه الدفعة',
  'This payment': 'هذه الدفعة',
  'Still owing after': 'المتبقي بعدها',
  'Leave it unpaid': 'اتركها غير مسددة',

  /* ---- How a client's documents state their amounts ---- */
  'New documents start as': 'تبدأ المستندات الجديدة بـ',
  'How amounts are stated on a new invoice or bill for this client. They can still change it on the document itself.':
    'كيف تُعرض المبالغ في فاتورة أو فاتورة مورّد جديدة لهذا العميل. ويظل بإمكانهم تغييرها في المستند نفسه.',
  'This document is stated with no tax, so lines carry no rate.':
    'هذا المستند معروض بدون ضريبة، لذا لا تحمل البنود أي نسبة.',

  /* ---- Tracked inventory items ---- */
  'Cost of goods sold account': 'حساب تكلفة البضاعة المباعة',
  'No account of this kind in Xero yet': 'لا يوجد حساب من هذا النوع في Xero بعد',

  /* ---- No more drafts: everything is filed as a finished document ---- */
  'What you file is filed': 'ما تُرسله يُقيَّد',
  'What you enter goes into your books as a finished document. There is no queue at our end and nothing waiting on us before you can be paid.':
    'ما تُدخله يدخل دفاترك مستنداً نهائياً. لا يوجد طابور لدينا ولا شيء ينتظرنا قبل أن تتمكن من التحصيل.',
  'Filed in Xero': 'قُيّد في Xero',
  'Sent by the backend, which owns the OAuth tokens. Created as AUTHORISED with an Idempotency-Key so a retry cannot duplicate.':
    'يُرسَل من الخادم الذي يملك رموز OAuth. يُنشأ بحالة AUTHORISED مع مفتاح Idempotency-Key حتى لا تُكرّر إعادة المحاولة المستند.',

  /* ---- Balance sheet and the aged detail reports ---- */
  'Balance sheet': 'الميزانية العمومية',
  'What the company owns and owes on one day. Prepared by Xero.':
    'ما تملكه الشركة وما عليها في يوم واحد. من إعداد Xero.',
  'Aged receivables detail': 'تفصيل أعمار الذمم المدينة',
  'Aged payables detail': 'تفصيل أعمار الذمم الدائنة',
  'Every unpaid invoice for one customer. Prepared by Xero.':
    'كل فاتورة غير مسددة لعميل واحد. من إعداد Xero.',
  'Every unpaid bill for one supplier. Prepared by Xero.':
    'كل فاتورة مورّد غير مسددة لمورّد واحد. من إعداد Xero.',
  'Back to aged receivables summary': 'العودة إلى ملخص أعمار الذمم المدينة',
  'Back to aged payables summary': 'العودة إلى ملخص أعمار الذمم الدائنة',
  'Show every document behind this figure': 'اعرض كل مستند وراء هذا الرقم',

  /* ---- Setting a password for somebody else ---- */
  'Set their password': 'عيّن كلمة المرور الخاصة بهم',
  'Set password': 'تعيين كلمة المرور',
  'New password': 'كلمة مرور جديدة',
  'New password for': 'كلمة مرور جديدة لـ',
  'The password for': 'كلمة المرور الخاصة بـ',
  'Change the password': 'غيّر كلمة المرور',
  'Suggest one': 'اقترح واحدة',
  /* 'Show' is already above. */
  'Hide': 'إخفاء',
  'I have it': 'سجّلتها',
  'Leave this empty and they set their own password from the sign-in page. The code Microsoft emails them can take a few minutes to arrive.':
    'اترك هذا الحقل فارغاً ليضعوا كلمة مرورهم بأنفسهم من صفحة الدخول. قد يستغرق الرمز الذي ترسله Microsoft بالبريد بضع دقائق حتى يصل.',
  'You will see this password once, after access is given. It is not stored anywhere.':
    'سترى كلمة المرور هذه مرة واحدة بعد منح الصلاحية. وهي لا تُحفظ في أي مكان.',
  'At least 12 characters, with three of: a small letter, a capital, a digit, a symbol.':
    'اثنا عشر حرفاً على الأقل، وتشمل ثلاثة من الآتي: حرف صغير، حرف كبير، رقم، رمز.',
  'Their old password stops working straight away. Nothing is emailed to them, so tell them what it is.':
    'تتوقف كلمة مرورهم القديمة عن العمل فوراً. ولا يُرسل إليهم أي بريد، لذا أخبرهم بها بنفسك.',
  'Write it down or tell them now. It is shown here once and is not stored anywhere — not by us, and not in a form anybody can read back. If it is lost, set a new one.':
    'دوّنها أو أخبرهم بها الآن. تظهر هنا مرة واحدة ولا تُحفظ في أي مكان — لا لدينا، ولا بصورة يمكن لأحد قراءتها لاحقاً. وإذا ضاعت، عيّن غيرها.',
  'Access was given, but the password was not set: that address already had a sign-in. They keep the password they already have, or can reset it from the sign-in page.':
    'مُنحت الصلاحية، لكن كلمة المرور لم تُعيَّن: لهذا العنوان حساب دخول قائم بالفعل. يحتفظون بكلمة مرورهم الحالية، أو يمكنهم إعادة تعيينها من صفحة الدخول.',
  'Only CFO Advisory and Accountancy can set the password of one of its own people.':
    'وحدها «CFO Advisory and Accountancy» يمكنها تعيين كلمة مرور أحد منسوبيها.',
  'Their sign-in was not created here, so its password cannot be set from this screen. They can still use "Forgot password?" on the sign-in page.':
    'لم يُنشأ حساب دخولهم من هنا، لذا لا يمكن تعيين كلمة مروره من هذه الشاشة. وبإمكانهم استخدام «نسيت كلمة المرور؟» في صفحة الدخول.',
  'This service has not been given permission to change passwords in the directory. An administrator has to grant it once: the User-PasswordProfile.ReadWrite.All permission, and the User Administrator role on the app itself. Both are needed.':
    'لم تُمنح هذه الخدمة صلاحية تغيير كلمات المرور في الدليل. على المسؤول منحها مرة واحدة: صلاحية User-PasswordProfile.ReadWrite.All، ودور User Administrator على التطبيق نفسه. وكلاهما مطلوب.',
  'The directory did not answer. Nothing was changed. Please try again.':
    'لم يستجب الدليل. لم يتغيّر شيء. يُرجى المحاولة مرة أخرى.',
  'The directory refused that password.': 'رفض الدليل كلمة المرور هذه.',
  'A password cannot begin or end with a space.':
    'لا يمكن أن تبدأ كلمة المرور بمسافة أو تنتهي بها.',
  'A password needs at least 12 characters.':
    'يجب ألا تقل كلمة المرور عن اثني عشر حرفاً.',
  'A password cannot be longer than 128 characters.':
    'لا يمكن أن تتجاوز كلمة المرور مئة وثمانية وعشرين حرفاً.',
  'A password needs three of these four: a small letter, a capital, a digit, a symbol.':
    'تحتاج كلمة المرور إلى ثلاثة من هذه الأربعة: حرف صغير، حرف كبير، رقم، رمز.',
  'Send them this address yourself. If you set a password above, that is all they need. If you did not, they choose "Forgot password?" on the sign-in page and collect the code Microsoft emails them — which can take a few minutes and is worth checking the junk folder for.':
    'أرسل إليهم هذا العنوان بنفسك. إن كنت قد عيّنت كلمة مرور أعلاه فهذا كل ما يلزمهم. وإن لم تفعل، فليختاروا «نسيت كلمة المرور؟» في صفحة الدخول ويأخذوا الرمز الذي ترسله Microsoft بالبريد — وقد يستغرق بضع دقائق، ويستحسن البحث عنه في مجلد البريد غير المرغوب فيه.',
};
